/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable @typescript-eslint/strict-boolean-expressions */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { SiteProxy, Method } from '../utils/SiteProxy'
import { trackPromise } from 'react-promise-tracker'
import { AxiosResponse, AxiosError } from 'axios'
export class BizlinkSdk {
  private static bizlinkSdk: BizlinkSdk
  public navigate: any
  public translate: any
  public static getInstance(): BizlinkSdk {
    if (!BizlinkSdk.bizlinkSdk) {
      BizlinkSdk.bizlinkSdk = new BizlinkSdk()
    }
    return BizlinkSdk.bizlinkSdk
  }

  // constructor() {}

  public async trigger(method: Method, json: { pathName: string; [key: string]: any }, isTracking?: boolean) {
    console.log('submit', json)
  
    // add current pathname & mode
    console.log('send this to internal server with method', method, 'and json', json)
    const apiPath = `/linklogic/${json.pathName}`
    console.log('apiPath',apiPath)
    
    return await trackPromise(
      SiteProxy.getInstance()
        .sendRequest(method, '/site/biz_link/trigger', json)
        .then((res: AxiosResponse) => {
          console.log('res', res)
          // window.tracking.trackingApi('tracking', {
          //   event: 'request api',
          //   responseDetail: res.data
          // })
          return res.data
        })
    ).catch((err: AxiosError) => {
      console.log('Axios internal error')
      // call tracking when error
      const response = err.response != null ? err.response : ''
      // call linklogic tracking

      // window.tracking.trackingApi('tracking', {
      //   event: 'request api',
      //   responseDetail: err.response && err.response.data.error
      // })
      throw err
    })
  }

  public async tracking(
    url: string,
    payload: {
      [x: string]: any
      user_id?: string | undefined
      event: 'visit page' | 'click button' | 'request api'
      location?: any
      date?: string | undefined
    }
  ) {
    // call tracking
    return await SiteProxy.getInstance()
      .sendRequest('POST', `/site/biz_link/${url}`, {
        pathName: 'tracking',
        payload
      })
      .then(res => {
        return res.data
      })
      .catch((err: any) => {
        throw err
      })
  }

  public async getUserProfile(userId: string) {
    return await trackPromise(
      SiteProxy.getInstance()
        .sendRequest('GET', `/site/users/${userId}?source=BizLink`)
        .then(res => {
          console.log('get user success', res)
          return res.data
        })
    ).catch((err: any) => {
      throw err
    })
  }

  public hideFooter = (pathName: string) => {
    const page = [
      '/single-card',
      '/card-selector',
      '/confirm-product',
      '/edit-product-card',
      '/multiple-card',
      '/survey',
      '/register-form'
    ]
    console.log(page.indexOf(pathName))
    if ((document as any).getElementById('footer-page') !== null) {
      if (page.includes(pathName)) {
        ;(document as any).getElementById('footer-page').style.display = 'none'
      } else {
        ;(document as any).getElementById('footer-page').style.display = 'block'
      }
    }
  }
}
